<template>
    <div ref="mainHigh" class="mianLogin">
        <div class="backTop">
            <LeftOutlined class="fl" @click="goMore('/webHighEnterpriseEvaluation?bottom_nav_ico=1')"/>
        </div>
        <div class="logoTop">
            <!-- <div class="imgs">
               <img src="./img/logo_notext.png" alt="">
            </div> -->
            <h3>修改信息</h3>
        </div>
        <div class="input-groud">
            <div class="imgUpload">
                <img-upload v-model:value="form.thumbnail" />
            </div>
            <input v-model="form.watc" type="text" placeholder="请输入验证码">
            <div class="captchaCode">
              <canvas @click="generateCaptcha" ref="captchaCanvas" width="120" height="30"></canvas>
            </div>
        </div>
        <a-button class="subtn" size="large" type="primary"  @click="submit()">确认修改</a-button>
    </div>
  </template>
  
  <script>
  export default {
    
    data () {
        return {
            captcha:null,
            form:{
                photo:null,
                watc:null
            }
        }
    },
    mounted() {
      this.$refs.mainHigh.style.height = window.innerHeight+'px'
      this.generateCaptcha();//验证码
    },
    methods: {
        submit(){
            if(this.form.watc){
                if(this.form.watc.toLowerCase()==this.captcha.toLowerCase()){
                        console.log(this.form)
                        this.goMore('/webHighEnterpriseEvaluation?bottom_nav_ico=1') 
                    }else{
                        this.generateCaptcha();//验证码
                        alert('请输入正确的验证码！')
                    }
            }else{
                alert('请正确填写手机号和验证码！')
            }
        },
        //路由跳转
        goMore(url, str) {
            if(str){
                this.$router.push({ path: url, query: { id: str } })
            }else{
                this.$router.push(url)
            }
        },
        //验证码部分start
        generateCaptcha() {
            const canvas = this.$refs.captchaCanvas;
            const ctx = canvas.getContext('2d');
    
            // 验证码背景色\
            ctx.fillStyle = 'rgb(220, 255, 255)'
            ctx.fillRect(0, 0, canvas.width, canvas.height);
    
            // 验证码字符集
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    
            // 生成4位随机验证码
            let captcha = '';
            for (let i = 0; i < 4; i++) {
            const char = characters[Math.floor(Math.random() * characters.length)];
    
            // 随机生成字符的颜色
            const color = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`;
            ctx.fillStyle = color;
            ctx.font = 'bold 36px Arial';
            ctx.fillText(char, 30 * i, 28);
    
            captcha += char;
            }
    
            // 将生成的验证码存储起来或发送给后端进行验证
            this.captcha = captcha
            console.log('生成的验证码:', captcha);
            
        }
        //验证码部分end
    }
  };
  </script>
  <style lang="less" scoped>
  .mianLogin{
    font-family: '微软雅黑';
    width:100%;
    background: url(./img/bg.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    font-size: 1.1rem;
    flex-direction: column;
    align-items: center;
    .backTop{
        width:100%;
        text-align: center;
        height:2rem;
        padding-top: .2rem;
        font-size: 1.1rem;
        .fl{
            float: left;
            margin:.3rem 0 0 1rem;
        }
    }
    .logoTop{
        width:80vw;
        margin-top: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom:2rem;
        font-weight: bold;
        .imgs{
            border-radius: 8rem;
            width:8rem;
            height:8rem;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom:.5rem;
        }
    }
    .input-groud{
        display: flex;
        margin-top: 1rem;
        flex-direction: column;
        width:80vw;
        padding: 0 1rem;
        background: #fff;
        position: relative;
        border-radius: .4rem;
        .imgUpload{
            width:5rem;
            height:5rem;
            margin:1rem auto;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            border-radius: 4rem;
        }
        .captchaCode{
            position:absolute;
            right:1rem;
            bottom:.8rem;
            z-index: 999;
        }
        
        input{
            flex:1;
            line-height: 3.1rem;
            font-size: 1rem;
            color:#3d3d3d;
            padding:.5rem;
            &:focus{
                border-style: none;
                outline: none;
            }
            border:0;
            height:3rem
        }
    }
    .subtn{
        width:80vw;
        margin-top:2rem;
        padding:.8rem 0 2.4rem;
        font-size: 1.1rem;
        background: #1c4ff7;
        text-align: center;
    }
  }
  </style>